module.exports = __webpack_public_path__ + "img/seta.0c795953.svg";